import Anna from '../../../../assets/images/Campaign/Colour/Anna/anna_hero.png';
import Mack from '../../../../assets/images/Campaign/Colour/Mack/mack_hero.png';
import Dina from '../../../../assets/images/Campaign/Colour/Dina/dina_hero.png';
import Payal from '../../../../assets/images/Campaign/Colour/Payal/payal_hero.png';
import Acton from '../../../../assets/images/Campaign/Colour/Acton/acton_hero.png';
import Aleksandra from '../../../../assets/images/Campaign/Colour/Aleksandra/aleksandra_hero.png';
import Ziggy from '../../../../assets/images/Campaign/Colour/Ziggy/ziggy_hb.png';
import Sonia from '../../../../assets/images/Campaign/Colour/Sonia/sonia_hero.png';
import { ColourTheme } from '../../../../types/ColourTheme';

export const personaToHeroImg: Record<ColourTheme, string> = {
  [ColourTheme.cerulean]: Anna,
  [ColourTheme.skyblue]: Mack,
  [ColourTheme.pomegranate]: Dina,
  [ColourTheme.orchidpink]: Payal,
  [ColourTheme.greensea]: Acton,
  [ColourTheme.jade]: Aleksandra,
  [ColourTheme.carrot]: Ziggy,
  [ColourTheme.sunflower]: Sonia,
  [ColourTheme.default]: Anna,
};

export const personaToIgLink: Record<ColourTheme, string> = {
  [ColourTheme.cerulean]: 'annathenutritionist',
  [ColourTheme.skyblue]: 'mackfitt',
  [ColourTheme.pomegranate]: 'dina.does',
  [ColourTheme.orchidpink]: 'payalia',
  [ColourTheme.greensea]: 'trainwithacton',
  [ColourTheme.jade]: 'aleksflows',
  [ColourTheme.carrot]: 'zig.fitmama',
  [ColourTheme.sunflower]: 'soniahoi',
  [ColourTheme.default]: 'annathenutritionist',
};
